<div class="position-relative text-grey">
    <div class="modal-header">
      <h4 class="modal-title synchpc-primary" id="modal-title" matTooltip="Add GPO">Add Group Policy Object(GPO)</h4>
      <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onCancel()" title="Close"></i>
    </div>
    <div class="modal-body">
      <div>
        <form name="addGpoForm"
              [formGroup]="addGpoForm"
              autocomplete="off"
              spellcheck="false">
  
          <mat-form-field class="w-100" style="height: 71px; font-size: small;">
            <mat-label>Group Policy Object(GPO) name</mat-label>
            <input matInput
                  placeholder="Group Policy Object(GPO) name"
                  formControlName="gpoName"
                  matTooltip="Add a GPO created in domain controller." 
                  style="font-size:14px;"/>
            <mat-error *ngIf="addGpoForm.get('gpoName').invalid" style="font-size:x-small">Enter Group Policy Object(GPO) name.</mat-error>
          </mat-form-field>
  
          <mat-form-field class="w-100" style="height: 71px; font-size: small;">
            <mat-label>Delegated User Id</mat-label>
            <input matInput
                  placeholder="Delegated User Id"
                  formControlName="gpoDelegatedUsername"
                  matTooltip="Enter id of the user delegated for entered GPO" 
                  style="font-size:14px;"/>
            <mat-error *ngIf="addGpoForm.get('gpoDelegatedUsername').invalid" style="font-size:x-small">Enter User Id.</mat-error>
          </mat-form-field>

          <mat-form-field class="w-100" style="height: 71px; font-size: small;">
            <mat-label>Delegated User Password</mat-label>
            <input matInput
                  [type]="!fieldTextType ? 'text' : 'password'"
                  placeholder="Delegated User Password"
                  formControlName="gpoDelegatedUserPassword"
                  matTooltip="Enter password for entered delegated user"
                  style="font-size: 14px;"/>
                  <mat-icon
                    *ngIf="addGpoForm.get('gpoDelegatedUserPassword').value != (null || '')"
                    (click)="togglePassswordIcon()"
                    style="font-size: 100% !important"
                    matSuffix
                    class="bi classPassIcon"
                    [ngClass]="{
                      'bi-eye-fill': fieldTextType,
                      'bi-eye-slash-fill': !fieldTextType
                    }"
                  ></mat-icon>
            <mat-error *ngIf="addGpoForm.get('gpoDelegatedUserPassword').invalid" style="font-size:x-small">Enter password.</mat-error>
          </mat-form-field>
        </form>
      </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary me-2" (click)="onCancel()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="onSubmit(addGpoForm)">Add</button>
    </div>
    <ngx-spinner bdColor="rgba(0,0,0,0)"
    size="default" zIndex="1"
    color="var(--s-primary-color)"
    type="ball-spin"
    [fullScreen]="false"
    name="gpoList"><p class="pleaseWait">Please wait ...</p></ngx-spinner>
</div>
